import Home from './views/Home.blacklisting'

export default {
  Home
}
